var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0051 25.625L15.0001 14.375M25.3239 21.4475C26.3248 20.7436 27.0754 19.7391 27.4668 18.5797C27.8581 17.4204 27.8698 16.1665 27.5001 15C26.742 12.6062 24.4189 11.2944 21.9083 11.2969H20.4576C20.1115 9.94724 19.4636 8.69375 18.5629 7.63075C17.6622 6.56775 16.532 5.72296 15.2575 5.15998C13.983 4.597 12.5974 4.3305 11.205 4.38055C9.81255 4.4306 8.44965 4.79589 7.21885 5.44893C5.98806 6.10196 4.92147 7.02572 4.09937 8.15064C3.27727 9.27556 2.72109 10.5723 2.47272 11.9433C2.22435 13.3143 2.29025 14.7238 2.66546 16.0656C3.04067 17.4075 3.71542 18.6467 4.6389 19.69",
    stroke: "#667085",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9775 17.2725L15 13.295L11.0225 17.2725",
    stroke: "#667085",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.e96dc2153b4d43a2fb5f0d52e00267c2.svg";
export { ForwardRef as ReactComponent };